<template>
  <modal
    :exibir="exibir"
    @fechar="fecharModal"
    titulo="Filiações & Responsáveis"
    :campos="$refs"
    id="modalVinculosFormulario"
    :ocultarRodape="true"
  >
    <div>
      {{ $t('ACADEMICO_MATRICULAS.VINCULOS_COMPONENTE_DESCRICAO') }}

      <!-- validarPreenchimento -->
      <b-form class="row py-4">
        <b-form-group class="col-12">
          <InputSelectTyping
            ref="pessoaId"
            v-model="pessoa.pessoaId"
            :options="pessoas"
            :label="$t('ACADEMICO_MATRICULAS.SELECIONE_PESSOA')"
            placeholder="ACADEMICO_MATRICULAS.DIGITE_PARA_FILTRAR"
            required
            @pesquisa-nome="buscarPessoaSemMatriculaPorNome"
            :loading="loadingPessoas"
          />
        </b-form-group>

        <b-form-group class="col-12">
          <input-select-search
            ref="tipoFiliacao"
            v-model="pessoa.tipoFiliacao"
            :options="tiposFiliacao"
            :label="$t('ACADEMICO_MATRICULAS.VINCULO_COM_ALUNO')"
            placeholder="ACADEMICO_MATRICULAS.DIGITE_PARA_FILTRAR"
            required
            :loading="loadingTipoFiliacao"
          />
        </b-form-group>

        <b-form-group class="col-12">
          <input-select-search
            ref="tipoResponsavel"
            v-model="pessoa.tipoResponsavel"
            :options="tiposResponsaveis"
            :label="$t('ACADEMICO_MATRICULAS.RESPONSAVEL_POR')"
            placeholder="ACADEMICO_MATRICULAS.DIGITE_PARA_FILTRAR"
            required
            :loading="loadingTipoResponsavel"
          />
        </b-form-group>
      </b-form>

      <div class="d-flex justify-content-between">
        <b-button variant="secondary" @click="fecharModal()">
          {{ $t('GERAL.FECHAR') }}
        </b-button>
        <b-button variant="primary" @click="salvar()">
          {{ $t('GERAL.ADICIONAR') }}
        </b-button>
      </div>
    </div>
  </modal>
</template>

<script>
//aux & helpers
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';

//Services
import PessoaService from '@/common/services/pessoa/pessoa.service';
import EnumeradoresService from '@/common/services/enumeradores/enumeradores.service';

// components
import Modal from '@/components/modal/Modal.vue';
import { InputSelectSearch, InputSelectTyping } from '@/components/inputs';

export default {
  components: {
    Modal,
    InputSelectSearch,
    InputSelectTyping,
  },
  props: {
    exibir: { type: Boolean, default: false },
    form: { type: Object, default: Object },
  },
  data() {
    return {
      pessoasNaoVinculadas: [],
      tipoHistorico: '',
      pessoas: [],
      tiposFiliacao: [],
      tiposResponsaveis: [],
      pessoa: {
        vinculado: false,
        pessoaId: '',
        pessoa: {},
        nome: '',
        codigo: '',
        tipoFiliacao: '',
        tipoFiliacaoDescricao: '',
        tipoResponsavel: '',
        tipoResponsavelDescricao: '',
      },
      opcoes: {
        tipoHistorico: [],
      },
      loadingPessoas: false,
      loadingTipoFiliacao: false,
      loadingTipoResponsavel: false,
    };
  },
  mounted() {
    //this.pegarEnumTipoHitorico();
  },
  methods: {
    buscarPessoaSemMatriculaPorNome(nome) {
      this.loadingPessoas = true;
      PessoaService.buscarTodosSemMatriculaPorNome(nome)
        .then((data) => {
          this.pessoas = data.itens;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.loadingPessoas = false;
        });
    },
    listarTiposFiliacao() {
      this.loadingTipoFiliacao = true;
      EnumeradoresService.listar('grau-parentesco')
        .then(({ data }) => {
          this.tiposFiliacao = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.loadingTipoFiliacao = false;
        });
    },
    listarTipoResponsavel() {
      this.loadingTipoResponsavel = true;
      EnumeradoresService.listar('tipo-responsaveis')
        .then(({ data }) => {
          data = data.map((row) => ({
            ...row,
            text: row.descricao,
            value: row.id,
            codigo: row?.codigo,
          }));
          this.tiposResponsaveis = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.loadingTipoResponsavel = false;
        });
    },
    validarFormulario() {
      return helpers.validarFormulario(this.$refs);
    },
    salvar() {
      if (!this.validarFormulario(this.$refs)) return;
      this.form.vinculos.push({ ...this.pessoa, desvinculado: true });
      this.fecharModal();
    },
    fecharModal() {
      this.$emit('fechar');
    },
  },
  watch: {
    exibir(valor) {
      if (valor) {
        this.listarTiposFiliacao();
        this.listarTipoResponsavel();
      }
      this.pessoa = {
        pessoaId: '',
        pessoa: {},
        nome: '',
        codigo: '',
        tipoFiliacao: '',
        tipoFiliacaoDescricao: '',
        tipoResponsavel: '',
        tipoResponsavelDescricao: '',
      };
    },
    'pessoa.pessoaId'(valor) {
      let pessoa = this.pessoas.find((pessoa) => {
        return pessoa.id == valor;
      });
      this.pessoa.codigo = pessoa?.codigo;
      this.pessoa.nome = pessoa?.nome;
      this.pessoa.cpf = pessoa?.cpf;
      this.pessoa.pessoa = pessoa;
    },
    'pessoa.tipoFiliacao'(valor) {
      let tipoFiliacao = this.tiposFiliacao.find((tipoFiliacao) => {
        return tipoFiliacao.id == valor;
      });
      if (tipoFiliacao) {
        this.pessoa.tipoFiliacaoDescricao = tipoFiliacao.descricao;
      }
    },
    'pessoa.tipoResponsavel'(valor) {
      let tipoResponsavel = this.tiposResponsaveis.find((tipoFiliacao) => {
        return tipoFiliacao.id == valor;
      });
      if (tipoResponsavel) {
        this.pessoa.tipoResponsavelDescricao = tipoResponsavel.descricao;
      }
    },
  },
};
</script>
